var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _class2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import GroupTraits from "./GroupTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import UrlTraits from "./UrlTraits";
export let FacetFilterTraits = (_dec = primitiveTrait({
  name: "Facet name",
  type: "string",
  description: "Name of facet"
}), _dec2 = primitiveTrait({
  name: "Facet value",
  type: "string",
  description: "Value of facet to use as filter"
}), _class = class FacetFilterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "value", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let SocrataCatalogGroupTraits = (_dec3 = primitiveArrayTrait({
  name: "Facet groups",
  description: "Facets to include in group structure. By default, `tags` and `categories` will be used,",
  type: "string"
}), _dec4 = objectArrayTrait({
  name: "Facets filter",
  type: FacetFilterTraits,
  description: "Facets (key/value pairs) to use to filter datasets.",
  idProperty: "name"
}), _dec5 = anyTrait({
  name: "Filter Query",
  description: "Gets or sets the filter query to pass to Socrata when querying the available data sources and their groups."
}), _class2 = class SocrataCatalogGroupTraits extends mixTraits(UrlTraits, CatalogMemberTraits, LegendOwnerTraits, GroupTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "facetGroups", _descriptor3, this);
    _initializerDefineProperty(this, "facetFilters", _descriptor4, this);
    _initializerDefineProperty(this, "filterQuery", _descriptor5, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "facetGroups", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ["tags", "categories"];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "facetFilters", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "filterQuery", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _class2);
export { SocrataCatalogGroupTraits as default };